// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bb74f6cb","455":"cd4ec133"}[chunkId] + ".chunk.js";
};